import React from 'react';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import ToggleButton from '@material-ui/lab/ToggleButton';
import Tooltip from '@material-ui/core/Tooltip';
import ViewAllIcon from '@material-ui/icons/Public';
import TokenUsersIcon from '@material-ui/icons/AccountBalance';
import UsersOnlyIcon from '@material-ui/icons/People';
import TokensOnlyIcon from '@material-ui/icons/Polymer';
import useStyles from './sharedStyles';

// Add component-specific styles
import { makeStyles } from '@material-ui/core/styles';
const useButtonStyles = makeStyles((theme) => ({
  toggleButton: {
    color: 'rgba(255, 255, 255, 0.6)',
    padding: '8px',
    minWidth: '40px',
    minHeight: '40px',
    margin: '0 2px',
    '& svg': {
      fontSize: '1.5rem', // Make icons larger
    },
    '&.Mui-selected': {
      backgroundColor: '#1976d2', // Bright blue background
      color: '#ffffff', // Bright white for the icon
      border: '3px solid #ffffff', // Thick white border
      boxShadow: '0 0 12px rgba(255, 255, 255, 0.7), 0 0 20px rgba(25, 118, 210, 0.7)', // Strong glow effect
      transform: 'scale(1.15)', // Make selected button slightly larger
      '&:hover': {
        backgroundColor: '#1565c0', // Darker blue on hover while selected
      },
    },
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.2)', // More visible hover state
      color: '#ffffff',
    },
    // Transition for smooth animation
    transition: 'all 0.2s ease-in-out',
  },
}));

/**
 * GraphViewModeSelector component provides UI controls to switch between different graph view modes
 * 
 * @param {Object} props - Component props
 * @param {string} props.viewMode - Current view mode ('all', 'token_connected', 'users_only', 'tokens_only')
 * @param {function} props.onViewModeChange - Callback when view mode changes
 */
const GraphViewModeSelector = ({ viewMode, onViewModeChange }) => {
  const classes = useStyles();
  const buttonClasses = useButtonStyles();

  const handleChange = (event, newViewMode) => {
    if (newViewMode !== null) {
      onViewModeChange(newViewMode);
    }
  };

  return (
    <div className={classes.graphViewModeSelector}>
      <ToggleButtonGroup
        value={viewMode}
        exclusive
        onChange={handleChange}
        aria-label="graph view mode"
        size="small"
        style={{ backgroundColor: 'rgba(0, 0, 0, 0.7)', padding: '4px', borderRadius: '8px' }}
      >
        <Tooltip title="Show all nodes and connections">
          <ToggleButton value="all" className={buttonClasses.toggleButton} aria-label="show all">
            <ViewAllIcon />
          </ToggleButton>
        </Tooltip>
        <Tooltip title="Show tokens and their connected users">
          <ToggleButton value="token_connected" className={buttonClasses.toggleButton} aria-label="tokens and connected users">
            <TokenUsersIcon />
          </ToggleButton>
        </Tooltip>
        <Tooltip title="Show only user connections">
          <ToggleButton value="users_only" className={buttonClasses.toggleButton} aria-label="users only">
            <UsersOnlyIcon />
          </ToggleButton>
        </Tooltip>
        <Tooltip title="Show only tokens (with icons)">
          <ToggleButton value="tokens_only" className={buttonClasses.toggleButton} aria-label="tokens only">
            <TokensOnlyIcon />
          </ToggleButton>
        </Tooltip>
      </ToggleButtonGroup>
    </div>
  );
};

export default GraphViewModeSelector;
